<article
  [routerLink]="link()"
  class="bg-blue-primary flex cursor-pointer items-start gap-2 rounded-md p-3 shadow-[0px_3px_6px_0px_#00000065] transition-all duration-200 hover:shadow-[0px_4px_10px_0px_#00000090]">
  <img
    [src]="user().avatar"
    [alt]="user().name"
    class="h-[51px] w-[59px] rounded-lg md:mr-4" />

  <div class="flex w-full flex-col items-start justify-stretch gap-4">
    <p class="font-barlow text-left text-sm leading-none font-bold text-white italic">
      {{ user().name }}
    </p>

    <div class="w-full">
      @let score = user().summary?.percentage || 0;
      <progress-bar [progress]="score"></progress-bar>
    </div>
  </div>
</article>
